import axiosapi from "./axiosAPI";

// Get All Comments
export const getNotifications = async (
    setNotifications,
    setIsLoadingNotifications,
    setFetcherrorNotifications,
    pkid
) => {
    
	try{
		const res =await axiosapi.get( pkid ? `/usernotifications?id=${pkid}`: "/allnotifications")
        setNotifications(res.data.data ? res.data.data : {});
        setIsLoadingNotifications(false)
        
	}
	catch(err){
		if(err.response){
            setFetcherrorNotifications(true);
			
		}else{
			//No response Obtained from the server.
            setFetcherrorNotifications(true);
		}
		
    }
    finally{
        setIsLoadingNotifications(false);
        setFetcherrorNotifications(false);
    }
	
};